// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610151337/js/" + chunkId + "." + {"44":"95e12101","225":"fca39adc","481":"7eb1abe4","486":"c353c499","770":"d463b1c0"}[chunkId] + ".0.0072879744687947.chunk.js";
};